import { useState } from 'react';
import { Button, Modal } from '../../atoms';
import { useModuleTranslation } from '../../utils/useModuleTranslation';
import './referral-approval-modal.modules.scss';

export type ReferralApprovalModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (file?: File) => Promise<void>;
};

const ReferralApprovalModal = ({ isOpen, onClose, onSubmit }: ReferralApprovalModalProps) => {
    const { t } = useModuleTranslation();
    const [selectedFile, setSelectedFile] = useState<File | undefined>(undefined);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        setSelectedFile(file);
    };

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            await onSubmit(selectedFile);
            setSelectedFile(undefined);
        } catch (error) {
            console.error('Error submitting referral approval:', error);
            throw error;
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        setSelectedFile(undefined);
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            showCloseButton
            title={t('referral_approval_modal.title')}
            onClose={handleClose}
            className="referral-approval-modal"
        >
            <div className="referral-approval-modal__body">
                <div className="referral-approval-modal__file-input">
                    <label htmlFor="referral-document">
                        {t('referral_approval_modal.upload_document')}
                        <span className="optional-label">{t('referral_approval_modal.optional')}</span>
                    </label>
                    <input
                        id="referral-document"
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={handleFileChange}
                    />
                    {selectedFile && <p className="selected-file-name">{selectedFile.name}</p>}
                </div>

                <div className="referral-approval-modal__actions">
                    <Button
                        text={t('referral_approval_modal.execute')}
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default ReferralApprovalModal;
